<ol class="breadcrumb mt-4 mb-0">
  <li class="breadcrumb-item" *ngFor="let breadcrumb of breadcrumbs" [ngClass]="{active: breadcrumb.active}">
    <a *ngIf="breadcrumb.link" [routerLink]="breadcrumb.link">{{breadcrumb.text}}</a><span *ngIf="!breadcrumb.link">{{breadcrumb.text}}</span>
  </li>
</ol>
